<template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permission.contract_del"
                   @click="handleDelete">删除
        </el-button>
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permission.contract_void"
                   @click="handleToVoid">作废
        </el-button>
      </template>

      <template slot="varNoNameForm">
        <autocomplete-reset v-model="form.varNoName"
                            typeUse="varNo"
                            :formData="form" />
      </template>
      <template slot="custNoNameForm">
        <autocomplete-reset v-model="form.custNoName"
                            typeUse="custNo"
                            :formData="form" />
      </template>
      <template slot="menu" slot-scope='scope'>
        <el-button type="text"
                   size="small"
                   icon="el-icon-circle-close"
                   v-if="permission.contract_audit_view"
                   @click="handleAuditView(scope.row)">审核流程查看
        </el-button>
      </template>
    </avue-crud>
    <el-dialog  :visible.sync="flowBox"
               append-to-body
               destroy-on-close
               title="流程图展示"
               width="70%"
               custom-class="flow-design-dialog">
               <el-card shadow="hover">
                <div slot="header">
                  <span>流程信息</span>
                </div>
                <el-row type="flex" class="row-bg">
                  <el-timeline>
                    <el-timeline-item :key="flow.id" :timestamp="flow.createTime" v-for="flow in flowList" placement="top">
                      <el-card shadow="hover">
                        <p>{{flow.assigneeName}} 在 [{{flow.createTime}}] 开始处理 [{{flow.historyActivityName}}] 环节</p>
                        <p v-if="flow.historyActivityDurationTime!==''">任务历时 [{{flow.historyActivityDurationTime}}]</p>
                        <p v-if="flow.comment!==''">批复意见: [{{flow.comment}}]</p>
                        <p v-if="flow.endTime!==''">结束时间: [{{flow.endTime}}]</p>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>
                </el-row>
              </el-card>
              <el-card shadow="hover" style="margin-top: 21px;">
                <div slot="header">
                  <span>流程图展示</span>
                </div>
                <flow-design :is-display.sync="flowBox" :process-instance-id="processInstanceId"></flow-design>
              </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {getList, getDetail, add, update, remove, toVoid} from "@/api/demo/contract";
import {historyFlowList} from "@/api/work/process";
import crudmixins from "@/basic-common/mixins/crudmixins.js";
import {mapGetters} from "vuex";
import validator from "@/util/validate.js";
import {desensitizationDispose} from "@/basic-common/util/desensitization.js";

const mixin = new crudmixins({add, getDetail, getList, remove, toVoid, update})

export default {
  mixins: [mixin],
  data() {
    return {
      processInstanceId: '',
      flowBox: false,
      flowList: [],
      option: {
        ...this.$store.state.publicOption,
        menuWidth: 280,
        column: [

          {
            label: "合同号",
            prop: "contractNo",
            overHidden: true,
            search: true,
            maxlength: 32,
            editDisabled: true,
            rules: [{
              required: true,
              message: "请输入合同号",
              trigger: "blur"
            }],
          },
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            overHidden: true,
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: "货主",
            prop: "custNoName",
            overHidden: true,
            rules: [{
              required: true,
              message: "请输入货主",
              trigger: "change"
            }],
          },
          {
            label: "物资名称",
            prop: "varNo",
            type: "select",
            hide: true,
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            overHidden: true,
            showColumn: false,
            remote: true,
            dicUrl: '/api/blade-vardict/vardict/searchCode?searchCode={{key}}',
            props: {
              label: "varName",
              value: "varNo"
            },
          },
          {
            label: "物资名称",
            prop: "varNoName",
            overHidden: true,
            rules: [{
              required: true,
              message: "请输入物资名称",
              trigger: "change"
            }],
          },
          {
            label: "单价(元)",
            prop: "unitPrice",
            align: 'right',
            maxlength: 9,
            numFormat: true,
            formslot: true,
            overHidden: true,
            rules: [{
              required: true,
              validator: validator.positiveNum2,
              trigger: "blur"
            }],
          },
          {
            label: "合同额(元)",
            prop: "contractAmount",
            align: 'right',
            maxlength: 9,
            numFormat: true,
            formslot: true,
            overHidden: true,
            rules: [{
              required: true,
              validator: validator.positiveNum2,
              trigger: "blur"
            }],
          },
          {
            label: '有效开始时间',
            prop: 'contractStartTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请选择开始时间',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '有效结束时间',
            prop: 'contractEndTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请选择结束时间',
                trigger: 'blur'
              }
            ]
          },
          {
            label: "审核状态",
            prop: "auditFlag",
            type: "select",
            dataType: 'string',
            exportProp: 'auditFlagName',
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            showColumn: false,
            overHidden: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_flag",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          // {
          //   label: "待审核人",
          //   prop: "pendingAuditUserName",
          //   showColumn: false,
          //   addDisplay: false,
          //   editDisplay: false,
          //   viewDisplay: true,
          //   overHidden: true,
          // },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            search: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "录入人",
            prop: "createUserName",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "录入时间",
            prop: "createTime",
            hide: false,
            showColumn: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "更新人",
            prop: "updateUserName",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "更新时间",
            prop: "updateTime",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "合同说明",
            prop: "remark",
            type: "textarea",
            hide: true,
            maxlength: 200,
            showWordLimit: true,
            span: 24,
            minRows: 6,
            overHidden: true,
          }
        ]
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.contract_add, false),
        viewBtn: this.vaildData(this.permission.contract_view, false),
        delBtn: false,
        editBtn: this.vaildData(this.permission.contract_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = desensitizationDispose(res.data.data);
        });
      } else if (type == 'add') {
        this.form = {}
      }
      done();
    },
    handleAuditView(row) {
      this.processInstanceId = row.processInstanceId;
      historyFlowList(this.processInstanceId).then(res => {
        const data = res.data;
        if (data.success) {
          this.flowList = data.data;
        }
      })
      this.flowBox = true;
    },
    // 自定义作废
    handleToVoid() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据作废?', '提示信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return toVoid(this.ids);
        })
        .then((res) => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: res.data.msg
          });
        })
    },
  }
};
</script>

<style>
</style>
